import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';

export const addCostingTemplateService = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.COSTING_TEMPLATE.ADD_COSTING_TEMPLATE}`, { templates: [...data] });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getCostingTemplateListService = async (query) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.COSTING_TEMPLATE.GET_COSTING_TEMPLATE_LIST}`, {
      params: { ...query },
    });
  } catch (error) {
    console.log(error);

    throw error;
  }
};

export const getCostingTemplateListByDevOrderService = async (devOrderId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.COSTING_TEMPLATE.GET_COSTING_TEMPLATE_LIST_BY_DEV_ORDER}/${devOrderId}`);
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getCostingTemplateDeatailByIdService = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.COSTING_TEMPLATE.COMMON_API_PATH}/${id}`);
  } catch (error) {
    console.log(error);

    throw error;
  }
};

export const getCostingTemplateDeatailByIdsService = async (id, devOrderId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.COSTING_TEMPLATE.CUSTOM_COSTING_TEMPLATE}/${devOrderId}/${id}`);
  } catch (error) {
    console.log(error);

    throw error;
  }
};

export const addAddtionalColumnService = async (obj) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.COSTING_TEMPLATE.COMMON_API_PATH}/${obj.id}`, { ...obj });
  } catch (error) {
    console.log(error);

    throw error;
  }
};

export const addLandedInfoColumnService = async (objs) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.COSTING_TEMPLATE.COMMON_API_PATH}/${objs.id}`, { ...objs });
  } catch (error) {
    console.log(error);

    throw error;
  }
};

export const updateCostingtemplateNameService = async (obj) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.COSTING_TEMPLATE.UPDATE_COSTING_TEMPLATE_NAME}/${obj._id}`, { name: obj.name, vat: obj.vat });
  } catch (error) {
    console.log(error);

    throw error;
  }
};

export const deleteCostingTemplateService = async (deleteId) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.COSTING_TEMPLATE.DELETE_COSTING_TEMPLATE}`, {
      data: deleteId,
    });
  } catch (error) {
    console.log(error);

    throw error;
  }
};

export const deleteCostingTemplateColumnService = async (body) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.COSTING_TEMPLATE.COMMON_COSTING_COLUMN}/${body.templateId}/${body.columnId}`, {
      data: { type: body.type },
    });
  } catch (error) {
    console.log(error);

    throw error;
  }
};

export const updateAddtionalColumnService = async (obj) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.COSTING_TEMPLATE.COMMON_COSTING_COLUMN}/${obj.id}/${obj.column._id}`, { ...obj });
  } catch (error) {
    console.log(error);

    throw error;
  }
};

export const updateLandedInfoColumnService = async (objs) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.COSTING_TEMPLATE.COMMON_COSTING_COLUMN}/${objs.id}/${objs.columnId}`, { ...objs });
  } catch (error) {
    console.log(error);

    throw error;
  }
};

export const updateLandedInfoColumnServiceActiveInActive = async (objs) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.COSTING_TEMPLATE.COSTING_ACTIVE_INACTIVE}/${objs.id}/${objs.columnId}`, { ...objs });
  } catch (error) {
    console.log(error);

    throw error;
  }
};

export const copyCostingTemplateDocService = async (id) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.COSTING_TEMPLATE.COPY_COSTING_TEMPLATE}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const setCTAdditionalSequence = async (params, data, section) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.COSTING_TEMPLATE.UPDATE_ADDITIONAL_SEQUENCE}/${params}`, {
      sequence: [...data],
      section,
    });
  } catch (error) {
    console.log(error);

    throw error;
  }
};
export const setCTLandedSequence = async (params, data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.COSTING_TEMPLATE.UPDATE_LANDED_SEQUENCE}/${params}`, {
      sequence: [...data],
    });
  } catch (error) {
    console.log(error);

    throw error;
  }
};
export const setMultiDeleteLandedSequence = async (params, data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.COSTING_TEMPLATE.MULTI_DELETE_SEQUENCE}/${params}`, {
      data,
    });
  } catch (error) {
    console.log(error);

    throw error;
  }
};

export const updateCostingTemplate = async (obj) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.COSTING_TEMPLATE.UPDATE_COSTING_ALL_CHANGES}/${obj._id}`, obj);
  } catch (error) {
    console.log(error);

    throw error;
  }
};

export const getCostingTemplateDetailColSizeLenByIdsService = async (id, devOrderId, obj) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.COSTING_TEMPLATE.COSTING_TEMPLATE_NEW_INFO_DETAILS}/${devOrderId}/${id}`, {
      params: { ...obj },
    });
  } catch (error) {
    console.log(error);

    throw error;
  }
};
